import React from "react";
import SimplePopover from "../components/form/SimplePopover";
import FlatBedImg from '../images/flatBed.svg';
import { toTitleCase } from "../utils/textTransform";

export default {
  addressLine1: "Address Line One",
  addressLine2: "Address Line Two",
  city: "City",
  state: "State",
  Zip_Code: "Zipcode",
  zip: "Zip",
  zipCodeHelpText: "(Example: 12345)",
  confirmation: "Confirmation",
  introText: vehicleDetails => {
    return (
      <div>
        We are contacting you on behalf of{" "}
        <strong>{vehicleDetails[0].sellerCompany}</strong> regarding your{" "}
        <strong>
          {vehicleDetails[0].year} {vehicleDetails[0].make}{" "}
          {vehicleDetails[0].model} {vehicleDetails[0].color}
        </strong>. If this isn't you, disregard and press the following button.
      </div>
    );
  },

  //`We are contacting you on behalf of ${name}. If this isn't you, disregard and press the following button`,
  notMe: "This is not me",
  insuranceCompany: "Insurance Company",
  adjusterName: "Adjuster",
  ownerName: "Owner Name",
  lotNumber: "Reference",
  claimNumber: "Claim",
  vehicleYear: "Year",
  vehicleMake: "Make",
  vehicleModel: "Model",
  vehicleColor: "Color",
  vin: "VIN",
  address: "Pickup Address",
  changeAddress: "Change Pickup Address",
  next: "Next",
  back: "Back",
  submit: "Submit",
  addressNotMatched:
    "We couldn't match your address with Google Maps, would you like to use their suggested address?",
  useSuggestedAddress: "Use Suggested Address",
  myAddress: "My Address",
  useMyAddress: "Use This Address",
  personal_information: "Personal Information",
  confirm_information: "Please confirm your information",
  address: "Pickup Address",
  vehicle_information: "Vehicle Information",
  title_information: "Title Information",
  confirm_title_page: "Please confirm title information",
  confirm_vehicle_ready: "Please confirm your vehicle is ready for pickup",
  yes: "Yes",
  no: "No",
  need_more_time: "No, I need more time",
  donot_intend_to: "No, I do not intend to",
  do_not_have_keys: "No, I do not have them",
  hours_2: "2 hours",
  hours_4: "4 hours",
  hours_8: "8 hours",
  other: "Other",
  pickup_on: "Pickup on",
  follow_up_in: "Please follow up in",
  tires_inflated: "Tires are inflated",
  vehicle_engine_starts: "Vehicle engine starts",
  vehicle_can_drive_safely: "Vehicle can drive safely under own power",
  none: "None",
  required_field: "Required Field",
  invalid_input: "Invalid Input",
  ensure_to_sign_your_title: "Please ensure to sign your title at the location shown below",
  Otherwise_sign_limited_power_of_attorney: "Otherwise please sign this limited power of attorney for us to process the vehicle:",
  get_started: "Get Started",
  network_error: "networkError",
  api_failure: "apiFailure",
  resubmit_form: "Errors in the form. Please resubmit",
  select: "Select",
  close: "close",
  isReadyForPickup: "Is your vehicle ready for pickup?",
  reason: "Reason",
  needToRemoveItems: "I need to remove items and property",
  insuranceNotSettled: "I have not yet settled with my insurance",
  vehicleNotAccessible: "My vehicle not accessible or no longer",
  vehicleDetailsNotCorrect: "My vehicle details are not correct",
  other: "Other",
  readyAfter: "Ready after",
  doesItDrive: "Does vehicle drive?",
  doesItRoll: "Are your wheels inflated and able to turn freely?",
  personalBelongings: "Have you removed personal belongings?",
  pickUpWithBelongings:
    "Are you sure you want Copart to pick your vehicle with your personal belongings in it?",
  isAnythingBlockingComment: "Comment",
  isAnythingBlocking: () => (
    <span>
      Is anything blocking your vehicle from being picked up by large tow truck?{" "}
      <SimplePopover img={FlatBedImg} heading="2 cars carrier" />
    </span>
  ),
  hasKeys: "Are keys with the vehicle?",
  policyHolder: "Policy Holder will be at home?",
  ownerPresent: "May we pick up your vehicle unattended?",
  isTitleAvailable: 'Do you have the title?',
  isOwnerTitle: "Are you the owner listed on the title?",
  actualOwnerName: "Who is the owner listed on the title?",
  ownerRelation: "What is your relationship to the owner listed on the title?",
  titleClear: "Is title free and clear?",
  lienInstitution: "What institution is listed as a lien-holder on the title?",
  signTitle: "Please sign the title",
  signTime: "Please follow up with me in",
  frontPhoto: "Please include front and back of your title",
  vehiclePhoto: "Please include a photo of your vehicle ",
  pickupTime: "Please choose time window for pick up",
  doesWheelsRoll: "Describe the running/rolling condition?",
  isTowable: "Towable",
  comments: "Comments",
  helpTextKey: "Please place the keys on the floor of the driver side or on the center console",
  keysTextKey: "Please leave keys and title in glove box and keep doors unlocked.",
  timeTextKey: "Please Note: We will try to honor your request, but may reach out to adjust as needed based on the availability and location of drivers",
  needToBePresent:
    "You do not need to be present for Copart to pickup vehicle, unless there is something preventing the driver from reaching your vehicle. You can leave keys in vehicle, in visor or on floor board.",
  needToBeThereForPickup:
    "Do you need to be there for pickup for driver to access the vehicle?",
  callBefore: "Would you like driver to call 30 minutes before pickup?",
  scheduledAppointment:
    "If you need to be present, do you need to have scheduled appointment?",
  scheduleAppointmentBusinessDays:
    "Please schedule appoinment in the following two business days:",

  vehicleDetails: "Vehicle Details:",
  confirmInfo:
    "Thank you for confirming your information. We will text you when driver is on its way.",
  contactUs: phone => {
    let ref = `tel:${phone}`;
    return (
      <div>
        If you need to update your response or have additional questions, please
        contact us at <a href={ref}>{phone}</a> during normal business hours(Monday through Friday from 8:00 am to 5:00 pm).
      </div>
    );
  },
  inconvenienceMessage:
    "Thank you for responding. We apologize for the inconvenience. Have a great day!",
  vehiclePickedUp:
    "Thank you for your coopertaion, your vehicle has been picked up.",
  callMeMessage: phone => {
    let ref = `tel:${phone}`;
    return (
      <div>
        If you have any questions, please
        contact us at <a href={ref}>{phone}</a> during normal business hours(Monday through Friday from 8:00 am to 5:00 pm).
      </div>
    );
  },
  callMe: "Call Me",
  networkFailureSubmit: phone => {
    let ref = `tel:${phone}`;
    return (
      <div>
        We couldn't submit your form! We apologize for the inconvenience. We
        will contact you or you can reach us at
        <a href={ref}>{phone}</a>
      </div>
    );
  },
  info: "info",
  networkFailure:
    "Sorry! It looks like there was a problem connecting to the server. Please try again later.",
  close: "close",
  noLotIdError: "Bad request",
  retry: "We are facing network issue. We apologize for the inconvenience. Please try again.",
  callMeSuccess: "Call Me Success",
  failedToFetchLotDetails: "Failed to fetch lot details. Try Reloading",
  failedToValidateAddress: "Failed to validate address. Try Reloading",
  callMeSuccess: "Our CSR will get back to you",
  couldntSubmitForm: phone => {
    let ref = `tel:${phone}`;
    return (
      <div>
        We couldn't submit your form! We apologize for the inconvenience. We
        will contact you or you can reach us at
        <a href={ref}>{phone}</a>
      </div>
    );
  },
  landingPageText: owner => {
    let ownerName = owner[0];
    if(owner[1]){
      return (
        <div>
          Hi <strong>{toTitleCase(ownerName)}</strong>, there are three easy steps to have
          your vehicle picked up!
          <ol className="lp-o-list">
            <li>Confirm your vehicle and personal information</li>
            <li>
              Confirm your title information
            </li>
            <li>
              Confirm the vehicle is prepared
              <ul>
                <li>Leave keys inside</li>
                <li>Make sure it’s accessible</li>
                <li>Remove your personal items</li>
              </ul>
            </li>
          </ol>
        </div>
      )
    }
    else{
      return (
        <div>
          Hi <strong>{toTitleCase(ownerName)}</strong>, there are two easy steps to have
          your vehicle picked up!
          <ol className="lp-o-list">
            <li>Confirm your vehicle and personal information</li>
            <li>
              Confirm the vehicle is prepared
              <ul>
                <li>Leave keys inside</li>
                <li>Make sure it’s accessible</li>
                <li>Remove your personal items</li>
              </ul>
            </li>
          </ol>
        </div>
      )
    }
  },
  partnershipText: () => <div>In partnership with <strong>Copart</strong></div>
};



// WEBPACK FOOTER //
// ./src/locale/en.js